import React from 'react'
import { dentalSpecialities } from '../../secondUtils/constants'

const DentalSpecialities = (props) => {
    const { selectedLanguage, language } = props
    const isELSelect = language?.language === 'english'
    const isAlSelect = language?.language === 'arabic'
    return (
        <div className='main'>
            <div className='DentalSpecialities-container'>
                <div className='DentalSpecialities-left-div'
                    data-aos="fade-right"
                    data-aos-easing="ease-out-bounce"
                    data-aos-delay="300"
                    data-aos-duration="2000">
                    <h1>{selectedLanguage?.txt_dental_specialties}</h1>
                    <p>{selectedLanguage?.txt_dental_specialties_text_1}</p>
                    <button>{selectedLanguage?.read_more_button}</button>
                </div>
                <div className='DentalSpecialities-right-div'
                    data-aos="fade-left"
                    data-aos-easing="ease-out-bounce"
                    data-aos-delay="300"
                    data-aos-duration="2000">
                    {
                        dentalSpecialities.map((v, i) => {
                            return (
                                <div>
                                    <h2>0{i + 1}.
                                        {isELSelect ? v?.name : (isAlSelect ? v?.alName : v?.glName)}
                                    </h2>
                                    <p>
                                        {isELSelect ? v?.text : (isAlSelect ? v?.alText : v?.glText)}
                                    </p>
                                </div>
                            )
                        })
                    }
                </div>
            </div>
            <div className="DentalSpecialities-footer"
                data-aos="fade-up"
                data-aos-easing="ease-out-bounce"
                data-aos-delay="200"
                data-aos-duration="1000">
                <div>
                    <div>
                        <h2 className="DentalSpecialities-text">{selectedLanguage?.txt_restoring_smile}
                        </h2>
                        <p className="DentalSpecialities-text-span">{selectedLanguage?.txt_doorway_smile}</p>
                    </div>
                    <div className="DentalSpecialities-btn-div">
                        <button>{selectedLanguage?.txt_get_started}</button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default DentalSpecialities